module.exports = __webpack_public_path__ + "img/tips@2x.0c9dbc9f.png";